export default __webpack_public_path__ + "static/error-messages-body-do-2cf94ff7e4cdfec04e108dc47edded33.png";